<template>
  <b-modal id="idModalListExports" title="Archivos Exportados (Máximo media hora de historial)" size="lg" centered @show="getExportUrls">
    <b-list-group v-if="exportUrls.length">
      <template v-for="(exportItem, index) in exportUrls">
        <b-list-group-item :key="index" :href="String(exportItem.url)" target="_blank">{{ exportItem.name }} {{ formatTimestamp(exportItem.timestamp) }}</b-list-group-item>
      </template>
    </b-list-group>
    <div v-else class="text-center">
      Por ahora no hay links válidos
    </div>
    <template #modal-footer="{ cancel }">
      <b-button size="sm" variant="outline-danger" @click="clearExportUrls">
        Limpiar Listado
      </b-button>
      <b-button size="sm" variant="success" @click="cancel()">
        Cerrar
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import dayjs from 'dayjs'
export default {
  data() {
    return {
      exportUrls: []
    }
  },
  mounted() {
    this.getExportUrls()
  },
  methods: {
    getExportUrls() {
      const exportUrls = localStorage.getItem('exportUrls')
      if (exportUrls) {
        const parsedUrls = JSON.parse(exportUrls)
        const now = dayjs()
        this.exportUrls = parsedUrls.filter(item => {
          const timestamp = dayjs(item.timestamp)
          return now.diff(timestamp, 'minute') <= 30
        })
      } else {
        this.exportUrls = []
      }
    },
    clearExportUrls() {
      localStorage.removeItem('exportUrls')
      this.exportUrls = []
    },
    formatTimestamp(timestamp) {
      return dayjs(timestamp).format('YYYY-MM-DD HH:mm')
    }
  }
}
</script>